import React from "react";

import { Spinner } from "react-bootstrap";

interface LoaderComponentProps {
  standalone?: boolean;
}
const LoaderComponent = ({
  standalone = true,
}: LoaderComponentProps): React.JSX.Element => (
  <div
    className={`d-flex flex-column justify-content-center align-items-center h-100 w-100 ${standalone ? "position-absolute" : ""}`}
  >
    <Spinner animation="border" />
  </div>
);

export default LoaderComponent;
